import { AccountRepository } from '../Repositories/AccountRepository';

export class DeleteAccountUseCase {
  constructor(private readonly repo: AccountRepository) {}

  execute(id: number): Promise<void> {
    return this.repo.deleteAccount(id).then(() => undefined).catch(err => Promise.reject(err));
  }
}
